"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPagesCount = exports.setNextRoute = exports.setCurrentPage = exports.setCanGoNext = exports.useProgress = exports.ProgressProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const reducer_1 = require("./reducer");
const state_1 = require("./state");
const ProgressContext = react_1.default.createContext(null);
function ProgressProvider({ children, }) {
    const [state, dispatch] = react_1.default.useReducer(reducer_1.reducer, state_1.initialState);
    const value = [state, dispatch];
    return ((0, jsx_runtime_1.jsx)(ProgressContext.Provider, { value: value, children: children }));
}
exports.ProgressProvider = ProgressProvider;
function useProgress() {
    const context = react_1.default.useContext(ProgressContext);
    if (context === undefined || context === null) {
        throw new Error('useProgress must be used within a ProgressContext');
    }
    return context;
}
exports.useProgress = useProgress;
var setCanGoNext_1 = require("./actions/setCanGoNext");
Object.defineProperty(exports, "setCanGoNext", { enumerable: true, get: function () { return setCanGoNext_1.setCanGoNext; } });
var setCurrentPage_1 = require("./actions/setCurrentPage");
Object.defineProperty(exports, "setCurrentPage", { enumerable: true, get: function () { return setCurrentPage_1.setCurrentPage; } });
var setNextRoute_1 = require("./actions/setNextRoute");
Object.defineProperty(exports, "setNextRoute", { enumerable: true, get: function () { return setNextRoute_1.setNextRoute; } });
var setPagesCount_1 = require("./actions/setPagesCount");
Object.defineProperty(exports, "setPagesCount", { enumerable: true, get: function () { return setPagesCount_1.setPagesCount; } });
